import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useT } from "@/i18n/LanguageContext";
import { imageSrc, srcSetFor } from "@/lib/imageSrc";

const BG = "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/sc8zrg9l_012%20LR.jpg";

function Word({ word, progress, range }) {
  const opacity = useTransform(progress, range, [0.12, 1]);
  return (
    <motion.span style={{ opacity }} className="inline">
      {word}{"\u00A0"}
    </motion.span>
  );
}

export default function Philosophy() {
  const { t } = useT();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.8", "end 0.2"] });

  const bgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  const phrase = t("philosophy.phrase").split(/\s+/);

  return (
    <section
      id="philosophy"
      ref={ref}
      data-testid="philosophy-section"
      className="relative w-full bg-ink text-bone py-[22vh] overflow-hidden"
    >
      {/* Background art — proxied via wsrv for WebP + JPG fallback at responsive widths. */}
      <picture>
        <source type="image/webp" srcSet={srcSetFor(BG, "webp")} sizes="100vw" />
        <motion.img
          style={{ y: bgY }}
          src={imageSrc(BG, 1200, "jpg")}
          srcSet={srcSetFor(BG, "jpg")}
          sizes="100vw"
          alt=""
          loading="lazy"
          decoding="async"
          width="2400"
          height="2400"
          className="absolute inset-0 w-full h-[140%] object-cover opacity-40 mix-blend-screen"
        />
      </picture>
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/60 to-ink" />

      <div className="relative z-10 px-6 md:px-10 max-w-6xl">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase opacity-70 mb-10">
          {t("philosophy.eyebrow")}
        </p>

        <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
          {phrase.map((w, i) => {
            const start = i / phrase.length;
            const end = start + 1 / phrase.length;
            return <Word key={`${w}-${i}`} word={w} progress={scrollYProgress} range={[start, end]} />;
          })}
        </h2>
      </div>
    </section>
  );
}
